import {
  CompanyLicensePlateDto,
  LicensePlateDto,
  LicensePlateRequestDto,
  LicensePlatesDataDto,
  RentalLicensePlateDto
} from '@app/data/dtos/ptrab/license-plates/license-plates.dto';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import {
  LicensePlate,
  LicensePlateRequest,
  LicensePlates
} from '@app/entities/models/ptrab/license-plates/license-plates.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapLicensePlate: MapFromFn<LicensePlateDto, LicensePlate> = (dto) =>
  Builder.forModel(LicensePlate).id(dto.id).numberPlate(dto.number_plate).build();

export const mapRentalLicensePlate: MapFromFn<RentalLicensePlateDto, LicensePlate> = (dto) =>
  Builder.forModel(LicensePlate)
    .id(dto.id)
    .numberPlate(dto.number_plate)
    .startDate(dto.start_date)
    .endDate(dto.end_date)
    .build();

export const mapCompanyLicensePlate: MapFromFn<CompanyLicensePlateDto, LicensePlate> = (dto) =>
  Builder.forModel(LicensePlate).id(dto.id).numberPlate(dto.number_plate).startDate(dto.start_date).build();

export const mapLicensePlatesData: MapFromFn<IDataResponse<LicensePlatesDataDto>, LicensePlates> = (dto) =>
  Builder.forModel(LicensePlates)
    .personal((dto?.data?.personal ?? []).map(mapLicensePlate))
    .rental((dto?.data?.rental ?? []).map(mapRentalLicensePlate))
    .company((dto?.data?.company ?? []).map(mapCompanyLicensePlate))
    .build();

export const mapLicensePlateToDto: MapFromFn<LicensePlateRequest, LicensePlateRequestDto> = (plate) =>
  Builder.forDto<LicensePlateRequestDto>()
    .number_plate(plate.numberPlate)
    .start_date(plate.startDate)
    .end_date(plate.endDate)
    .build();
